export default __webpack_public_path__ + "static/media/T14A.cadd0842.png";